import { render, staticRenderFns } from "./siteInfoTab.vue?vue&type=template&id=18912e2e&scoped=true&lang=pug"
import script from "./siteInfoTab.vue?vue&type=script&lang=js"
export * from "./siteInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18912e2e",
  null
  
)

export default component.exports